import { lazy } from 'react';

const loadHomePage = () => import('./HomePage');
export const HomePageLoad = lazy(loadHomePage);

const loadSecurityPage = () => import('./SecurityPage');
export const SecurityPageLoad = lazy(loadSecurityPage);

const loadSearchContractPage = () => import('./SearchContractPage');
export const SearchContractPageLoad = lazy(loadSearchContractPage);

const loadContractRequestPage = () => import('./ContractRequestPage');
export const ContractRequestPageLoad = lazy(loadContractRequestPage);
